/* ============================================
   SCARCITY LOGIC — incolla in assets/scarcity-badge.js
   oppure alla fine del tuo theme.js
   ============================================ */

(function () {
  const STORAGE_KEY   = 'scarcity_data';   // chiave localStorage
  const MAX_STOCK     = 10;                // mai superare questo numero
  const MIN_STOCK     = 1;                 // minimo visualizzabile
  const INTERVAL_MS   = 10 * 60 * 1000;   // 10 minuti in ms
  const RESET_MS      = 24 * 60 * 60 * 1000; // 24 ore in ms

  /**
   * Ritorna o inizializza lo stato persistente nel localStorage.
   * Struttura: { value, nextChange, resetAt }
   */
  function getState() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        const state = JSON.parse(raw);
        if (state && state.value && state.nextChange && state.resetAt) {
          return state;
        }
      }
    } catch (_) {}
    return null;
  }

  function saveState(state) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (_) {}
  }

  /**
   * Genera un numero casuale intero tra min e max (inclusi),
   * diverso dal valore attuale.
   */
  function randomDifferent(current, min, max) {
    let next;
    do {
      next = Math.floor(Math.random() * (max - min + 1)) + min;
    } while (next === current);
    return next;
  }

  /**
   * Inizializza o recupera lo stato e avvia i timer.
   */
  function init() {
    const el = document.getElementById('scarcity-count');
    if (!el) return;

    const now = Date.now();
    let state = getState();

    // Reset dopo 24 ore o primo avvio
    if (!state || now >= state.resetAt) {
      state = {
        value:      MAX_STOCK,
        nextChange: now + INTERVAL_MS,
        resetAt:    now + RESET_MS,
      };
      saveState(state);
    }

    // Aggiorna subito il DOM con il valore salvato
    updateDisplay(el, state.value, false);

    // Calcola quanto manca al prossimo cambio
    scheduleNext(el, state);
  }

  function updateDisplay(el, value, animate) {
    el.textContent = value;
    if (animate) {
      el.classList.remove('scarcity-count-update');
      // forza reflow per riattivare l'animazione
      void el.offsetWidth;
      el.classList.add('scarcity-count-update');
    }
  }

  function scheduleNext(el, state) {
    const now  = Date.now();
    const wait = Math.max(0, state.nextChange - now);

    setTimeout(function tick() {
      const currentState = getState();
      const ts = Date.now();

      // Ora di reset raggiunta → ripristina a 10
      if (ts >= currentState.resetAt) {
        const newState = {
          value:      MAX_STOCK,
          nextChange: ts + INTERVAL_MS,
          resetAt:    ts + RESET_MS,
        };
        saveState(newState);
        updateDisplay(el, newState.value, true);
        scheduleNext(el, newState);
        return;
      }

      // Cambia il numero (scende o sale ma mai > MAX_STOCK)
      const newValue = randomDifferent(
        currentState.value,
        MIN_STOCK,
        MAX_STOCK
      );

      const newState = {
        value:      newValue,
        nextChange: ts + INTERVAL_MS,
        resetAt:    currentState.resetAt,
      };
      saveState(newState);
      updateDisplay(el, newValue, true);
      scheduleNext(el, newState);
    }, wait);
  }

  // Avvia quando il DOM è pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
